/**
 * `/admin/project-categories` — la rotta storica delle categorie dei progetti. Resta per i
 * segnalibri e porta dove si configurano dal 03-11-2026: «Regole di lavoro → Categorie progetto».
 * Si possono anche creare, rinominare ed eliminare dal campo «Categoria» del progetto.
 */
import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/admin/project-categories')({
  component: () => <Navigate to="/organization/work-rules" search={{ section: 'project-categories' }} replace />,
});
